'use strict';

var premiumIndicator = premiumIndicator || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
premiumIndicator.init = function () {
  premiumIndicator.placement();

  // Fix behaviors.
  Drupal.behaviors.placement = {
    attach: function (context, settings) {
      premiumIndicator.placement();
    }
  };
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(premiumIndicator.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
// Set width on images wrapper
premiumIndicator.placement = function () {

    // console.log('premiumIndicator');

    var viewPremium = $('.view--premium-news-sheet-indicator');
    var viewRow = viewPremium.find('.view__row');

  viewPremium.each(function (index) {
    $(this).prependTo($(this).next('.field--title'));
  });

  setTimeout(function () {
    viewPremium.addClass('show')
  }, 400)
};
